import { navigation } from "./navigation";

export const usePathname = navigation.usePathname;
